import "./Products.scss";
import Product from "./Product/Product";
import { useParams } from "react-router-dom";

const Products = ({ innerPage, products, headingText }) => {
  const { id } = useParams(); // get the id parameter from the URL
  console.log(products)
  

  return (
    <div className="products-container">
      {!innerPage && <div className="sec-heading">{id}</div>}
      <div className={`products ${innerPage ? "innerPage" : ""}`}>
      {products?.map(({_id, name, brand, description, image, price, slug}) => {
    const productData = {
      _id,
      name,
      brand,
      description,
      image,
      price,
      slug
    };
    return <Product key={_id} data={productData} />;
})}
      </div>
    </div>
  );
};

export default Products;
